import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { RewardCardType, RewardPurchasePayload } from '@/types'
import { getRewards as getRewardsAPI, purchaseReward as purchaseRewardAPI } from '@/utils/requests/rewards'
import { useUserStore } from './user-store/user-store'

export const useRewardsStore = defineStore('rewardsStore', () => {
    const rewards = ref<RewardCardType[][]>([])
    const userStore = useUserStore()

    const getRewards = async () => {
        const rawRewards = await getRewardsAPI()
        const rewardTypes: Record<string, RewardCardType[]> = {}
        rawRewards.forEach((item) => {
            if (!rewardTypes[item.type]) {
                rewardTypes[item.type] = []
            }
            rewardTypes[item.type].push({
                ...item,
                // TODO SSR + think about cache
                currency: /* window.additionalServerData?.locale?.currency || */ 'usd',
            })
        })
        rewards.value = Object.values(rewardTypes)
    }

    const purchaseReward = async (payload: RewardPurchasePayload) => {
        await purchaseRewardAPI(payload)
        // update user balance
        userStore.getUserTasks()
    }
    return {
        rewards,
        getRewards,
        purchaseReward,
    }
})
